// src/components/ModalSucessoContrato.tsx
import React from 'react';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface ModalSucessoContratoProps {
    show: boolean;
    onHide: () => void;
    idContrato?: number;
    idOportunidade?: string | null; // Modificado para aceitar null
}

const ModalSucessoContrato: React.FC<ModalSucessoContratoProps> = ({
    show,
    onHide,
    idContrato,
    idOportunidade
}) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <div className="modal-header border-0 m-0 justify-content-end">
                <button
                    className="btn-close"
                    onClick={onHide}
                    aria-label="Close"
                >
                    <i className="ti ti-x" />
                </button>
            </div>
            <div className="modal-body">
                <div className="success-message text-center">
                    <div className="success-popup-icon bg-light-blue">
                        <i className="ti ti-file-invoice" />
                    </div>
                    <h3>Oportunidade Atualizada e Contrato Criado</h3>
                    <p>
                        A oportunidade foi atualizada e um novo contrato foi criado com sucesso.
                    </p>
                    <div className="col-lg-12 text-center modal-btn">
                        {idOportunidade && (
                            <Link
                                to={`/crm/oportunidades/detalhes/${idOportunidade}`}
                                className="btn btn-light me-2"
                            >
                                Ver Oportunidade
                            </Link>
                        )}
                        {idContrato && (
                            <Link
                                to={`/crm/contratos/detalhes/${idContrato}`}
                                className="btn btn-primary"
                            >
                                Ver Contrato
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ModalSucessoContrato;
